import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CarouselMain from "./components/CarouselMain";
import Call from "./components/Call";
import PorqueElegirnos from "./components/PorqueElegirnos";
import Services from "./components/Services";
import Footer from "./components/Footer";
import ImgStart from "./components/ImgStart";
import Formulario from "./components/Formulario"
import FormStart from "./components/FormStart"
import CasosExito from "./components/CasosExito";

function App() {
  return (
    <div>
      <Header />
      <CarouselMain />
      <FormStart/>
      <ImgStart />
      <Carousel />
      <Call />
      <PorqueElegirnos />
      <Services />
      <CasosExito/>
      <Formulario />    
      <Footer />
    </div>
  );
}

export default App;
